import { useEffect } from "react";

export default function useTheme(theme: string | null) {
  useEffect(() => {
    if (!theme) return;
    document.documentElement.style.setProperty("--theme", theme);
    return () => {
      document.documentElement.style.removeProperty("--theme");
    };
  }, [theme]);
}
